<template>
  <base-card dark>
    <v-img
      :src="require('@/assets/articles/loghomes.jpg')"
      class="grey lighten-2"
      height="100"
      width="100%"
      gradient="rgba(0, 0, 0, .3), rgba(0, 0, 0, 0)"
    >
      <v-row
        class="fill-height pa-3"
      >
        <v-col
          cols="12"
          md="12"
          offset-md="0"
        >
          <h1 class="display-2 font-weight-light" style="font-family: 'Stick', sans-serif !important;">
            XTERRA <span style="font-family: 'Raleway', sans-serif !important; font-size: 1.75rem; font-weight:500;"> SURFACE - EV CHARGING STATIONS</span>
          </h1>

          <!-- <div class="subheading text-uppercase mb-4" style="font-family: 'Montserrat', sans-serif !important;">
            Design, perfection and quality
          </div> -->

        </v-col>
      </v-row>
    </v-img>
  </base-card>
</template>

<script>
  export default {
    name: 'HomeBanner',
  }
</script>
